import BaseService from './base-service';

export default class NotificationService extends BaseService {
    constructor() {
        super('notifications');
    }
}
